/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} User_Detail_Left_Out_WithdrawnInputs */



/**
* | output |
* | --- |
* | "{count} event(s) left out of the per-game figures: withdrawn or disqualified." |
*
* @param {User_Detail_Left_Out_WithdrawnInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const user_detail_left_out_withdrawn = /** @type {((inputs: User_Detail_Left_Out_WithdrawnInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Detail_Left_Out_WithdrawnInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.count} tournoi(s) exclu(s) des chiffres par partie : abandon ou disqualification.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.count} torneo(s) excluido(s) de las cifras por partida: retirada o descalificación.`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`${i?.count} torneio(s) fora dos números por partida: desistência ou desqualificação.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.count} torneo/i escluso/i dalle cifre per partita: ritiro o squalifica.`)
	return /** @type {LocalizedString} */ (`${i?.count} event(s) left out of the per-game figures: withdrawn or disqualified.`)
});